import './Layout.scss';

import { DefaultRoutes } from 'Routes';
import { Notifications } from 'components/Notifications';
import { ReactComponent as Trackman } from 'icons/Trackman.svg';
import { useNavigate } from 'react-router';

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  const navigate = useNavigate();

  return (
    <div className='layout-content-container'>
      <div className='top-navigation' onClick={() => navigate(DefaultRoutes.Home, { viewTransition: true })}>
        <Trackman />
      </div>
      <div className='layout-content'>
        <Notifications />
        {children}
      </div>
    </div>
  );
};

export default Layout;
